<template>
    <div class="rows">
        <div style="margin-bottom: 10px;">
            <table class="table-border-none">
                <tr>
                    <td style="padding-left: 0;">Název:</td>
                    <td><input v-model="item.nazev" style="width: 400px;" /><span class="required">*</span></td>
                </tr>
                <tr>
                    <td style="padding-left: 0;">Kategorie:</td>
                    <td><input v-model="item.kategorie" style="width: 40px;" /><span class="required">*</span></td>
                </tr>
            </table>
        </div>
        <div class="cols" style="gap: 10px;">
            <button @click="saveItem">Uložit</button>
            <button @click="close">Zavřít</button>
            <button v-if="itemId !== -1" @click="deleteItem">Smazat</button>
        </div>
    </div>
</template>

<script>
    import api from '@/api/api.js'

    export default {
        name: 'EditTypDOSS',
        props: ['itemId'],
        data() {
            return {
                item: {
                    'id': -1,
                    'kategorie': '',
                    'nazev': ''
                }
            }
        },
        methods: {
            load() {
                if (this.itemId === -1) {
                    this.item = {
                        'id': -1,
                        'kategorie': '',
                        'nazev': ''
                    }
                }
                else {
                    this.$progress.start()
                    api.getTypDOSSById(this.itemId)
                    .then(response => {
                        this.$progress.finish()
                        this.item = response.data
                    })
                    .catch(error => { 
                        this.$progress.finish()
                        console.log('Error: ', error)
                    })
                }
            },
            close() {
                this.$emit('close')
            },
            saveItem() {
                if (confirm('Uložit záznam?')) {
                    if (this.item.nazev.length === 0 || this.item.kategorie.length === 0) {
                        alert('Záznam nebude uložen. Povinná pole jsou: Název, Kategorie')
                        return
                    }
                    else {
                        if (this.item.id === -1) {
                            this.$progress.start()
                            api.postTypDOSS(this.item)
                            .then(() => {
                                this.$progress.finish()
                                this.$emit('updateTable')
                                this.$emit('close')
                            })
                            .catch(error => { 
                                this.$progress.finish()
                                console.log('Error: ', error)
                                alert('Nastala chyba při ukládání. Záznam nebyl uložen.')
                            })
                        }
                        else {
                            this.$progress.start()
                            api.putTypDOSS(this.item.id, this.item)
                            .then(() => {
                                this.$progress.finish()
                                this.$emit('updateTable')
                            })
                            .catch(error => { 
                                this.$progress.finish()
                                console.log('Error: ', error)
                                alert('Nastala chyba při ukládání. Záznam nebyl uložen.')
                            })
                        }
                    }
                }
            },
            deleteItem() {
                if (confirm('VAROVÁNÍ! Tuto akci nelze vzít zpátky. Opravdu chcete smazat tento záznam?')) {
                    this.$progress.start()
                    api.deleteTypDOSS(this.item.id)
                    .then(() => {
                        this.$progress.finish()
                        this.$emit('updateTable')
                        this.$emit('close')
                    })
                    .catch(error => { 
                        this.$progress.finish()
                        console.log('Error: ', error)
                        alert('Nastala chyba při mazání. Záznam nebyl smazán.')
                    })
                }
            }
        },
        created() {
            this.load()
        },
        beforeUpdate() {
            if (this.itemId !== this.item.id) {
                this.load()
            }
        }
    }
</script>